// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Styles */
body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
    background-color: #f9f9f9;
  }
  
  /* Section Styling */
  .service-section-main-container {
    text-align: center;
    margin-top: 64px;
  }
  
  .heading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px; /* Adjust spacing between line and text */
    margin-bottom: 24px;
}

.green-line {
    width: 30px; /* Adjust width */
    height: 5px; /* Adjust thickness */
    background-color: #008D62; /* Green color */
    border-radius: 5px; /* Rounded edges */
}

.heading-text {
    font-size: 20px;
    font-weight: 600;
    color: #4A4A4A; /* Dark gray color */
    font-family: "Plus Jakarta Sans", sans-serif;
}

  
.service-section-heading-style {
  font-size: 28px;
  font-weight: 700;
  color: #212529;
  font-family: "Plus Jakarta Sans", serif;
  text-align: center;
  max-width: 500px; /* Restricts width to force wrapping */
  line-height: 1.4; /* Adjusts spacing between lines */
  word-wrap: break-word;
  margin: 0 auto 30px; /* Centers the text */
}

  
  /* Services Section */
  .service-section-card-main-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
  }
  
  .service-card-container-style {
    background: #F8F9FA;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    padding: 40px;
    border-radius: 10px;
    text-align: center;
    display: flex; /* Enables flexbox */
    flex-direction: column; /* Aligns content in a vertical column */
    align-items: center; /* Centers items horizontally */
    justify-content: center; /* Centers items vertically */
    width: 260px;
    transition: transform 0.3s ease-in-out;
}

.service-card-container-style:hover {
    transform: translateY(-5px);
}
.service-card-inside-icon-style {
    height: 60px;
    width: 60px; /* Ensure it's a square */
    margin-bottom: 20px;
    object-fit: contain; /* Ensures the image fits well */
    display: block;
}

.service-card-title-text-style {
    font-size: 24px;
    font-weight: 700;
    color: #212529;
    font-family: "Plus Jakarta Sans", serif;
    text-align: center;
}


  
  /* Responsive Design */
  @media (max-width: 768px) {
    .services-container,
    .features-container {
      flex-direction: column;
      align-items: center;
    }
  
    .service-card-container-style,
    .feature-card {
      width: 100%;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Home/Component/Service/serviceSection.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,8BAA8B;IAC9B,SAAS;IACT,UAAU;IACV,yBAAyB;EAC3B;;EAEA,oBAAoB;EACpB;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS,EAAE,yCAAyC;IACpD,mBAAmB;AACvB;;AAEA;IACI,WAAW,EAAE,iBAAiB;IAC9B,WAAW,EAAE,qBAAqB;IAClC,yBAAyB,EAAE,gBAAgB;IAC3C,kBAAkB,EAAE,kBAAkB;AAC1C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;IACpC,4CAA4C;AAChD;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB,EAAE,sCAAsC;EACxD,gBAAgB,EAAE,kCAAkC;EACpD,qBAAqB;EACrB,mBAAmB,EAAE,qBAAqB;AAC5C;;;EAGE,qBAAqB;EACrB;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,aAAa,EAAE,oBAAoB;IACnC,sBAAsB,EAAE,wCAAwC;IAChE,mBAAmB,EAAE,+BAA+B;IACpD,uBAAuB,EAAE,6BAA6B;IACtD,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,WAAW,EAAE,yBAAyB;IACtC,mBAAmB;IACnB,mBAAmB,EAAE,gCAAgC;IACrD,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,kBAAkB;AACtB;;;;EAIE,sBAAsB;EACtB;IACE;;MAEE,sBAAsB;MACtB,mBAAmB;IACrB;;IAEA;;MAEE,WAAW;IACb;EACF","sourcesContent":["/* Global Styles */\nbody {\n    font-family: Arial, sans-serif;\n    margin: 0;\n    padding: 0;\n    background-color: #f9f9f9;\n  }\n  \n  /* Section Styling */\n  .service-section-main-container {\n    text-align: center;\n    margin-top: 64px;\n  }\n  \n  .heading-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px; /* Adjust spacing between line and text */\n    margin-bottom: 24px;\n}\n\n.green-line {\n    width: 30px; /* Adjust width */\n    height: 5px; /* Adjust thickness */\n    background-color: #008D62; /* Green color */\n    border-radius: 5px; /* Rounded edges */\n}\n\n.heading-text {\n    font-size: 20px;\n    font-weight: 600;\n    color: #4A4A4A; /* Dark gray color */\n    font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\n  \n.service-section-heading-style {\n  font-size: 28px;\n  font-weight: 700;\n  color: #212529;\n  font-family: \"Plus Jakarta Sans\", serif;\n  text-align: center;\n  max-width: 500px; /* Restricts width to force wrapping */\n  line-height: 1.4; /* Adjusts spacing between lines */\n  word-wrap: break-word;\n  margin: 0 auto 30px; /* Centers the text */\n}\n\n  \n  /* Services Section */\n  .service-section-card-main-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 20px;\n  }\n  \n  .service-card-container-style {\n    background: #F8F9FA;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    padding: 40px;\n    border-radius: 10px;\n    text-align: center;\n    display: flex; /* Enables flexbox */\n    flex-direction: column; /* Aligns content in a vertical column */\n    align-items: center; /* Centers items horizontally */\n    justify-content: center; /* Centers items vertically */\n    width: 260px;\n    transition: transform 0.3s ease-in-out;\n}\n\n.service-card-container-style:hover {\n    transform: translateY(-5px);\n}\n.service-card-inside-icon-style {\n    height: 60px;\n    width: 60px; /* Ensure it's a square */\n    margin-bottom: 20px;\n    object-fit: contain; /* Ensures the image fits well */\n    display: block;\n}\n\n.service-card-title-text-style {\n    font-size: 24px;\n    font-weight: 700;\n    color: #212529;\n    font-family: \"Plus Jakarta Sans\", serif;\n    text-align: center;\n}\n\n\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .services-container,\n    .features-container {\n      flex-direction: column;\n      align-items: center;\n    }\n  \n    .service-card-container-style,\n    .feature-card {\n      width: 100%;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
